import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyOrderRoutingModule } from './my-order-routing.module';
import { MyOrdersComponent } from './my-orders.component';
import { AdsModule } from '../adcomponents/ad.module';
import { OpenOrdersComponent } from './open-orders/open-orders.component';
import { BackOrdersComponent } from './back-orders/back-orders.component';
import { ShippedOrdersComponent } from './shipped-orders/shipped-orders.component';
import { SearchOrdersComponent } from './search-orders/search-orders.component';
import { MyoderService } from './shared/myoder.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgProgressModule } from 'ngx-progressbar';
import { NgxPaginationModule } from 'ngx-pagination';
import { ExtendItemComponent } from './open-orders/extend-item/extend-item.component';
import { OrderItemDetailComponent } from './order-item-detail/order-item-detail.component';
import { SharedModule } from '../shared/shared.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OrderFilterPipe } from '../shared/pipes/orderfilter.pipe';
import { MatSortModule } from '@angular/material/sort';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { BreadcrumbModule } from '../breadcrumb/breadcumb.module';


@NgModule({
  imports: [
    CommonModule,
    MyOrderRoutingModule,
    FormsModule,
    AdsModule,
    NgProgressModule,
    NgxPaginationModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    SharedModule,
    NgbModule,
    MatSortModule, 
    ChildHeaderModule,
    MatButtonModule,
    BreadcrumbModule
  ],
  declarations: [
    MyOrdersComponent,
    OpenOrdersComponent,
    BackOrdersComponent,
    ShippedOrdersComponent,
    SearchOrdersComponent,
    OrderItemDetailComponent,
    ExtendItemComponent,
    OrderFilterPipe
  ],
  providers: [MyoderService]
})
export class MyOrderModule {}
